import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../../../core/services/auth.service';
import { Currency } from '../../../../shared/objects/order/currency';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class CurrencyService {

    private currencies: Currency[];

    constructor(
        private httpClient: HttpClient,
        private authService: AuthService,
      ) {
        this.getCurrenciesLocally();
    }

    getCurrency(currencyId: number): Currency {
        if (!currencyId || !this.currencies || this.currencies.length === 0) { return new Currency(); }

        const currency = this.currencies.find(c => c.currencyId === currencyId);
        return !!currency ? currency : new Currency();
    }

    private getCurrencies(): Observable<Currency[]> {
        const headers = this.authService.getBearerRequestHeaders();
        return this.httpClient.get<Currency[]>(environment.currencyServiceUrl, {
          headers
        });
    }

    private getCurrenciesLocally() {
        this.getCurrencies().subscribe(currencies => {
            this.currencies = currencies;
          });
    }
}
